import {createElement, Component, PropTypes} from 'rlink-react';
import warnOnce from 'rlink-debug-utils/warnOnce';
export default function (path, type = 'img') {
  try {
    switch (type) {
      case 'img':
        return require(`../static/img/${path}`);
        break;
      case 'video':
        return require(`../static/video/${path}`);
        break;
      default:
        throw new Error(`Invalid content loader type: ${type}`);
    }
  } catch (e) {
    warnOnce(`Couldn't load the ${type}: ${path}. Make sure this file exists.`);
  }

}



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/helpers/content-loader.jsx